import api from "./http";

export const bookVisit = (payload) => api.post("/visits/book", payload);

export const listMyVisits = () => api.get("/visits/me");

export const updateVisitStatus = (visitId, status) =>
  api.put(`/visits/${visitId}/status`, { status });

export const rescheduleVisit = (visitId, scheduled_time) =>
  api.put(`/visits/${visitId}/reschedule`, { scheduled_time });

export const cancelVisit = (visitId) => api.put(`/visits/${visitId}/cancel`);

export const getSlots = () => api.get("/visits/slots");
